import getApiHost from '../Utils/UrlUtils';

const API_URL = `${getApiHost()}/api/v1`;

// eslint-disable-next-line import/prefer-default-export
export const LOGIN_URL = `${API_URL}/auth/token/`;
export const REQUEST_URL = `${API_URL}/users/me`;
export const REFRESH_URL = `${API_URL}/auth/token/refresh/`;
